import { NotificationListFiltersEmailSmsDto } from '@dto/notification-list/notification-list-filters-email-sms.dto';
import { NotificationListDto } from '@dto/notification-list/notification-list.dto';
import { createAction, props } from '@ngrx/store';

const state = '[Notification List Email SMS]';

export const loadNotificationListEmailSms = createAction(
  `${state} Load notifications`,
  props<{
    currentPageNumber: number;
    filters: NotificationListFiltersEmailSmsDto;
    pageSize: number;
  }>()
);

export const loadNotificationListEmailSmsSuccess = createAction(
  `${state} Load notifications Success`,
  props<{ notificationList: NotificationListDto }>()
);

export const loadNotificationListEmailSmsFailure = createAction(
  `${state} Load notifications Failure`,
  props<{ error: string }>()
);

export const changeProductIdFilterEmailSms = createAction(
  `${state} Change productId filter`,
  props<{ filters: NotificationListFiltersEmailSmsDto }>()
);

export const changeProductIdFilterEmailSmsComplete = createAction(
  `${state} Change productId filter Complete`,
  props<{ successfulProductIds: { [productId: string]: string[] }; failedProductIds: { [productId: string]: string } }>()
);

export const loadPublicEmailProductIds = createAction(
  `${state} Load public email product ids`
);

export const loadPublicEmailProductIdsSuccess = createAction(
  `${state} Load public email product ids Success`,
  props<{ productIds: string[] }>()
);

export const loadPublicEmailProductIdsFailure = createAction(
  `${state} Load public email product ids Failure`,
  props<{ error: string }>()
);
